
import { Component, Prop, Mixins } from 'vue-property-decorator';
import Chart from 'chart.js';
import { Radar } from 'vue-chartjs';
import Evaluation from '@/models/evaluation/Evaluation';

Chart.defaults.global.defaultFontSize = 12;

@Component
export default class RadarChart extends Mixins(Radar) {
  @Prop()
  private data: Evaluation[];

  private chartData: Chart.ChartData = {};

  created() {
    const labels = this.data.map((val) => val.evaluationTitle?.match(/.{1,7}/g) ?? []) as string[][];
    const data = this.data.map((val) => val.correctRate) as number[];
    this.chartData = {
      labels,
      datasets: [{
        backgroundColor: '#9fbb0019',
        borderColor: '#9fbb00',
        pointBorderWidth: 4,
        pointHoverBorderWidth: 4,
        data,
      }],
    };
  }

  private chartOptions: Chart.ChartOptions = {
    legend: {
      display: false,
    },
    scale: {
      pointLabels: {
        fontSize: 16,
      },
      ticks: {
        min: 0,
        max: 100,
        stepSize: 20,
      },
      gridLines: {
        circular: true,
      },
    },
  };

  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
}
